/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_LabelInputs */

const en_resume_label = /** @type {(inputs: Resume_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const de_resume_label = /** @type {(inputs: Resume_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf`)
};

/**
* | output |
* | --- |
* | "Resume" |
*
* @param {Resume_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const resume_label = /** @type {((inputs?: Resume_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_label(inputs)
	return en_resume_label(inputs)
});